module.exports = __webpack_public_path__ + "apple-icon-72x72.d92cfdd2.png";